import { type ReactElement, useEffect, useState } from 'react';
import { getRootLayout } from '@/layout';
import { PRODUCT_HEADER_HEIGHT } from '@/shared/constants/productLayout.const';
import { useIsInExternalPlatform } from '@/shared/externalPlatform';
import { useIsSmallerThanTabletSm } from '@/shared/hooks/useIsSmallerThanTabletSm';
import { cn } from '@/utils/tailwind.util';
import { ProductBottomNavigation, ProductSidebar } from './ProductSidebar';
const ProductSidebarLayout = ({
  children,
  contentClassName
}: {
  children: ReactElement;
  contentClassName?: string;
}) => {
  const [isMounted, setIsMounted] = useState(false);
  const isSmallerThanTabletSm = useIsSmallerThanTabletSm();
  const isInExternalPlatform = useIsInExternalPlatform();
  const shouldShowSidebar = isMounted && !isSmallerThanTabletSm && !isInExternalPlatform;
  useEffect(() => {
    setIsMounted(true);
  }, []);
  if (isMounted && !shouldShowSidebar) {
    return <>
        <main className="pb-[calc(100px+env(safe-area-inset-bottom))] pt-md breakpoint-content-padding tablet-sm:pb-[80px] tablet-sm:pt-lg">
          {children}
        </main>
        {isSmallerThanTabletSm && !isInExternalPlatform && <ProductBottomNavigation />}
      </>;
  }
  return <div className="flex w-full bg-default" data-sentry-component="ProductSidebarLayout" data-sentry-source-file="ProductSidebarLayout.tsx">
      <div className="flex w-full items-start bg-default">
        <ProductSidebar style={{
        top: PRODUCT_HEADER_HEIGHT
      }} data-sentry-element="ProductSidebar" data-sentry-source-file="ProductSidebarLayout.tsx" />
        <main className={cn('min-w-0 flex-1 py-[12px] pb-[80px] pl-[24px] pr-[40px]',
      // 자체 하단 패딩을 가진 페이지(예: ClassroomDetailLayout)는 'pb-0' 로 중복 제거.
      contentClassName)}>
          {children}
        </main>
      </div>
    </div>;
};
export function getProductSidebarLayout(page: ReactElement, contentClassName?: string) {
  return getRootLayout(<ProductSidebarLayout contentClassName={contentClassName}>
      {page}
    </ProductSidebarLayout>);
}